<div [ngStyle]="{ 'height': height + 'px'}">
    <kendo-spreadsheet [sheets]="sheets"
                       style="height: 100%;"
                       *ngIf="sheets.length"
                       [menuItems]="items"
                       (change)="onChange($event, 'change')"
                       [columns]="colNumber"
                       [rows]="rowNumber"
                       (selectionChange)="onSelectionChange($event)"
                       [toolbar]="toolbar">
                       
    </kendo-spreadsheet>
</div>
